import PropTypes from 'prop-types';

const DocumentTypeDocIcon = ({ size = '24' }) => {
  return (
    <svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path fill="#2B559A" d="M4 2h12l4 4v16H4z" />
        <text
          fill="#FFF"
          fontFamily="SFMono-Heavy, SF Mono, Arial"
          fontSize="6"
          fontWeight="600"
        >
          <tspan x="6.437" y="19">
            DOC
          </tspan>
        </text>
        <path fill="#FFF" d="M7 6h9v1H7zM7 8h9v1H7zM7 10h6v1H7z" />
      </g>
    </svg>
  );
};

DocumentTypeDocIcon.propTypes = {
  size: PropTypes.string,
};

export default DocumentTypeDocIcon;
